export class FeatureUsage {
    name;
    type;
    currentUsage;
    static fromApi(data) {
        if (Array.isArray(data)) {
            return data.map((et) => FeatureUsage.define(et));
        }
        else if (data != null) {
            return FeatureUsage.define(data);
        }
        else
            return null;
    }
    static define(data) {
        let featureUsage = new FeatureUsage();
        featureUsage.name = data.Name;
        featureUsage.type = data.Type;
        featureUsage.currentUsage = data.CurrentUsage;
        return featureUsage;
    }
    /**
     * Converts an array of FeatureUsage objects into a lookup map where the key is the feature name
     * @param [usages]
     * @returns Record<string, FeatureUsage> a map object of feature names as keys
     *
     */
    static createMap(usages = []) {
        const map = {};
        for (const u of usages) {
            map[u.name] = u;
        }
        return map;
    }
    /**
     * Checks whether a feature has used up its available quota
     * @param usageMap a map created using createMap()
     * @param feature the feature object with its allowed quota
     * @returns a boolean which is true if the quota is reached (or exceeded)
     */
    static maxReached(usageMap, feature) {
        const usage = usageMap[feature.Name];
        if (!usage)
            return false;
        if (feature.Value.Quota === -1)
            return false;
        return usage.currentUsage >= feature.Value.Quota;
    }
    /**
     * Counts how many features have reached their quota
     * @param usageMap a map created using createMap()
     * @param features array of enabled features of the tier
     * @returns length of how many features are at or over quota
     */
    static countReached(usageMap, features = []) {
        return features.filter((f) => FeatureUsage.maxReached(usageMap, f)).length;
    }
}
